import { Node, mergeAttributes } from '@tiptap/core';
import { Plugin } from 'prosemirror-state';
import { getHeadings } from './numbered-headings-extension';
import { EditorState } from '@tiptap/pm/state';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    summary: {
      insertSummary: () => ReturnType;
      forceUpdateSummary: () => ReturnType;
    };
  }
}

interface SummaryOptions {
  getSummaryContent: () => HTMLElement;
}

export const Summary = Node.create<SummaryOptions>({
  name: 'summary',

  group: 'block',

  atom: true,
  selectable: false,
  draggable: false,

  addOptions() {
    return {
      getSummaryContent: () => document.createElement('div')
    };
  },

  parseHTML() {
    return [
      {
        tag: 'div.editor-summary'
      }
    ];
  },

  renderHTML({ HTMLAttributes }) {
    const container = this.options.getSummaryContent() || document.createElement('div');
    return ['div', mergeAttributes(HTMLAttributes, { class: 'editor-summary' }), ...Array.from(container.childNodes)];
  },

  addCommands() {
    return {
      insertSummary:
        () =>
        ({ commands }: any) => {
          return commands.insertContent({ type: this.name });
        },
      forceUpdateSummary:
        () =>
        ({ state }: any) => {
          return replaceSummaries(state, this);
        }
    } as any;
  },

  addProseMirrorPlugins() {
    const that = this;

    return [
      new Plugin({
        appendTransaction(transactions, oldState, newState) {
          const oldHeadings = getHeadings(oldState.doc);
          const newHeadings = getHeadings(newState.doc);

          if (oldHeadings.join('|') === newHeadings.join('|') && !that.editor.isEmpty) return null;

          replaceSummaries(newState, that);
          return;
        }
      })
    ] as any;
  }
});

export function replaceSummaries(state: EditorState, that: any) {
  state.doc.descendants((node: any, pos: number) => {
    setTimeout(() => {
      if (node.type.name === that.name) {
        const selection = that.editor.state.selection;

        that.editor
          .chain()
          .deleteRange({ from: pos, to: pos + 1 })
          .setMeta('addToHistory', false)
          .run();
        that.editor.chain().insertContentAt(pos, { type: 'summary' }).setTextSelection(selection).setMeta('addToHistory', false).run();
      }
    });
  });
}
